import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import { useStyles } from "./WeekTab.css";
import AddTimeTable from "../AddTimeTable";
import TimetableTab from "../TimetableTab/TimetableTab";

class WeekTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: "Sunday",
    };
  }

  handleCurrentPage = (e, newTab) => {
    this.setState({
      currentTab: newTab,
    });
  };

  showPage = (tab, weekId) => {
    switch (tab) {
      case "Sunday":
        return (
          <AddTimeTable
            weekName={tab}
            weekId={weekId}
            timeList={this.props.timeList}
            subjectList={this.props.subjectList}
            config={this.props.config}
            getTimeTable={this.props.getTimeTable}
          />
        );

      case "Monday":
        return (
          <AddTimeTable
            weekName={tab}
            weekId={weekId}
            timeList={this.props.timeList}
            subjectList={this.props.subjectList}
            config={this.props.config}
            getTimeTable={this.props.getTimeTable}
          />
        );

      case "Tuesday":
        return (
          <AddTimeTable
            weekName={tab}
            weekId={weekId}
            timeList={this.props.timeList}
            subjectList={this.props.subjectList}
            config={this.props.config}
            getTimeTable={this.props.getTimeTable}
          />
        );

      case "Wednesday":
        return (
          <AddTimeTable
            weekName={tab}
            weekId={weekId}
            timeList={this.props.timeList}
            subjectList={this.props.subjectList}
            config={this.props.config}
            getTimeTable={this.props.getTimeTable}
          />
        );

      case "Thursday":
        return (
          <AddTimeTable
            weekName={tab}
            weekId={weekId}
            timeList={this.props.timeList}
            subjectList={this.props.subjectList}
            config={this.props.config}
            getTimeTable={this.props.getTimeTable}
          />
        );

      case "Friday":
        return (
          <AddTimeTable
            weekName={tab}
            weekId={weekId}
            timeList={this.props.timeList}
            subjectList={this.props.subjectList}
            config={this.props.config}
            getTimeTable={this.props.getTimeTable}
          />
        );

      default:
        break;
    }
  };

  render() {
    const { classes } = this.props;
    const filtered = this.props.timeList.times.filter(
      (data) => data.weekName === this.state.currentTab
    );
    const weekId = filtered[0]._id;
    return (
      <Grid container spacing={2} style={{ marginTop: 10 }}>
        <Grid
          item
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className={classes.tab}
          style={{ padding: 0 }}
        >
          <TimetableTab
            handleCurrentPage={this.handleCurrentPage}
            currentTab={this.state.currentTab}
          />
        </Grid>
        <br />
        <Grid
          item
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          style={{ padding: 0 }}
        >
          {this.showPage(this.state.currentTab, weekId)}
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(useStyles)(WeekTab);
